export default __webpack_public_path__ + "static/media/Powered-by-SIX.3733bf9e.png";